import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Authenticated axios instance (sends the httpOnly session cookie)
export const authApi = axios.create({ baseURL: API, withCredentials: true });

export async function createLead(payload) {
  const res = await axios.post(`${API}/leads`, payload);
  return res.data;
}

export async function exchangeSession(session_id) {
  const res = await authApi.post("/auth/session", { session_id });
  return res.data;
}
export async function fetchMe() {
  const res = await authApi.get("/auth/me");
  return res.data;
}
export async function logout() {
  const res = await authApi.post("/auth/logout");
  return res.data;
}
export async function getStats() {
  const res = await authApi.get("/admin/stats");
  return res.data;
}
export async function getInbox(params) {
  const res = await authApi.get("/admin/inbox", { params });
  return res.data;
}
export async function getLead(id) {
  const res = await authApi.get(`/admin/inbox/${id}`);
  return res.data;
}
export async function patchLead(id, patch) {
  const res = await authApi.patch(`/admin/inbox/${id}`, patch);
  return res.data;
}
export async function replyLead(id, text, channel = "email") {
  const res = await authApi.post(`/admin/inbox/${id}/reply`, { text, channel });
  return res.data;
}
export async function aiDraft(id) {
  const res = await authApi.post(`/admin/inbox/${id}/ai-draft`);
  return res.data;
}
export async function aiSummarize(id) {
  const res = await authApi.post(`/admin/inbox/${id}/ai-summarize`);
  return res.data;
}

// ---- CRM ----
export async function crmList(params) {
  const res = await authApi.get("/admin/crm", { params });
  return res.data;
}
export async function crmStats() {
  const res = await authApi.get("/admin/crm/stats");
  return res.data;
}
export async function crmReminders() {
  const res = await authApi.get("/admin/crm/reminders");
  return res.data;
}
export async function crmDetail(id) {
  const res = await authApi.get(`/admin/crm/${id}`);
  return res.data;
}
export async function crmPatch(id, patch) {
  const res = await authApi.patch(`/admin/crm/${id}`, patch);
  return res.data;
}
export async function crmAddNote(id, text) {
  const res = await authApi.post(`/admin/crm/${id}/notes`, { text });
  return res.data;
}
export async function crmDeleteNote(id, noteId) {
  const res = await authApi.delete(`/admin/crm/${id}/notes/${noteId}`);
  return res.data;
}
export async function crmAddReminder(id, title, due_at) {
  const res = await authApi.post(`/admin/crm/${id}/reminders`, { title, due_at });
  return res.data;
}
export async function crmToggleReminder(reminderId, done) {
  const res = await authApi.patch(`/admin/crm/reminders/${reminderId}`, { done });
  return res.data;
}
export async function crmDeleteReminder(reminderId) {
  const res = await authApi.delete(`/admin/crm/reminders/${reminderId}`);
  return res.data;
}
